import {
  GANGAFFILIATIONS_TABLE,
  GET_GANGAFFILIATIONS_LIST_PENDING,
  GET_GANGAFFILIATIONS_LIST_FULFILLED,
  GET_GANGAFFILIATIONS_LIST_REJECTED,
  GET_GANGAFFILIATION_PENDING,
  GET_GANGAFFILIATION_FULFILLED,
  GET_GANGAFFILIATION_REJECTED,
  DELETE_GANGAFFILIATION_FULFILLED,
  DELETE_GANGAFFILIATION_PENDING,
  ADD_GANGAFFILIATION_FULFILLED,
  UPDATE_GANGAFFILIATION_FULFILLED
} from '../../actions/action-constants'
const initialState = {
  title: 'Gang Affiliations',
  tablename: GANGAFFILIATIONS_TABLE,
  gangaffiliations: [],
  loadingList: false,
  errors: []
}
const reducerGangAffiliations = (state = initialState, action) => {
  var dataUndefinedTestReturn
  switch (action.type) {
    case GET_GANGAFFILIATION_PENDING:
    case GET_GANGAFFILIATIONS_LIST_PENDING:
    case DELETE_GANGAFFILIATION_PENDING:
      state = {
        ...state,
        loadingList: true
      }
      break
    case GET_GANGAFFILIATIONS_LIST_FULFILLED:
      dataUndefinedTestReturn =
        typeof action.payload.data !== 'undefined' &&
        action.payload.data !== null
          ? action.payload.data.dropdowns
          : []
      state = {
        ...state,
        loadingList: false,
        addSuccess: false,
        updateSuccess: false,
        deleteSuccess: false,
        gangaffiliations: dataUndefinedTestReturn
      }
      break
    case GET_GANGAFFILIATION_FULFILLED:
      dataUndefinedTestReturn =
        typeof action.payload.data !== 'undefined' &&
        action.payload.data !== null
          ? action.payload.data.dropdowns
          : []
      state = {
        ...state,
        loadingList: false,
        gangaffiliations: dataUndefinedTestReturn
      }
      break
    case DELETE_GANGAFFILIATION_FULFILLED:
      state = {
        ...state,
        loadingList: false,
        deleteSuccess: true
      }
      break
    case ADD_GANGAFFILIATION_FULFILLED:
      state = {
        ...state,
        loadingList: false,
        addSuccess: true
      }
      break
    case UPDATE_GANGAFFILIATION_FULFILLED:
      state = {
        ...state,
        loadingList: false,
        updateSuccess: true
      }
      break
    case GET_GANGAFFILIATIONS_LIST_REJECTED:
    case GET_GANGAFFILIATION_REJECTED:
      state = {
        ...state,
        errors: [action.payload.response]
      }
      break
    default:
      return state
  }
  return state
}
export default reducerGangAffiliations
